import { majorScale, minorScale, Pane, Paragraph } from 'evergreen-ui';
import { get, map } from 'lodash';
import {
  formatDatetimeWithUTC,
  numberToCurrency,
} from '../../../../../helpers/functions';
import { UserWalletBadge } from './user-wallet';

const MobileUserWallet = ({ data, getStatusStyles }) => {
  return map(data, (tx, i) => {
    const currencySymbol = get(tx, 'currency.currencySymbol', false);

    const { bg, color } = getStatusStyles(tx?.type);

    return (
      <Pane
        key={i}
        borderBottom="1px solid var(--gray-default-color)"
        paddingY={majorScale(2)}
      >
        <Pane
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          marginBottom={majorScale(1)}
        >
          <Paragraph fontWeight={700} fontSize="1.125em">
            Date
          </Paragraph>
          <Paragraph fontWeight={400} fontSize="1.125em">
            {formatDatetimeWithUTC(get(tx, 'dateCreated', 'N/A'))}
          </Paragraph>
        </Pane>
        <Pane
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          marginBottom={majorScale(1)}
        >
          <Paragraph fontWeight={700} fontSize="1.125em">
            Amount
          </Paragraph>
          <Paragraph fontWeight={400} fontSize="1.125em">
            {numberToCurrency(
              get(tx, 'transactionValue', 'N/A'),
              currencySymbol
            )}
          </Paragraph>
        </Pane>
        <Pane
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          marginBottom={majorScale(1)}
        >
          <Paragraph fontWeight={700} fontSize="1.125em">
            Opening balance
          </Paragraph>
          <Paragraph fontWeight={400} fontSize="1.125em">
            {numberToCurrency(get(tx, 'openingBalance', 'N/A'), currencySymbol)}
          </Paragraph>
        </Pane>
        <Pane
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          marginBottom={majorScale(1)}
        >
          <Paragraph fontWeight={700} fontSize="1.125em">
            Closing balance
          </Paragraph>
          <Paragraph fontWeight={400} fontSize="1.125em">
            {numberToCurrency(get(tx, 'closingBalance', 'N/A'), currencySymbol)}
          </Paragraph>
        </Pane>
        <Pane
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          marginBottom={majorScale(1)}
        >
          <Paragraph fontWeight={700} fontSize="1.125em">
            Direction
          </Paragraph>
          <Paragraph fontWeight={400} fontSize="1.125em">
            <UserWalletBadge
              text={get(tx, 'type', 'N/A')}
              color={color}
              bgColor={bg}
            />
          </Paragraph>
        </Pane>
        <Pane>
          <Paragraph
            fontWeight={700}
            fontSize="1.125em"
            marginBottom={minorScale(1)}
          >
            Details
          </Paragraph>
          <Paragraph
            fontWeight={400}
            fontSize="1.125em"
            textTransform="capitalize"
          >
            {get(tx, 'transactionDetails', 'N/A')?.toLowerCase()}
          </Paragraph>
        </Pane>
      </Pane>
    );
  });
};

export default MobileUserWallet;
